// extracted by mini-css-extract-plugin
export default {"container":"descriptionTile_container__SJZRT","title":"descriptionTile_title__xhAx3","description":"descriptionTile_description__6P6TF","keypoint":"descriptionTile_keypoint__e+Jy7"};